<template>
  <div>
    <pageTitle :extinfo="extinfo"></pageTitle>
    <div class="info-list">
      <template
        v-for="(item, index) in infoList">
        <infos
          :key="index"
          :item="item"
          >
        </infos>
      </template>
      <noMore></noMore>
      <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
    </div>
  </div>
</template>

<script>
import { getInfoReport } from '@/api/artist'
import Infos from '@/components/infos/infos.vue'
import { changeTitleClick, wexinShare } from '@/utils/utils'
import { queryShart } from '@/api/user'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
import noMore from '@/components/noMore/noMore.vue'
export default {
  name: 'artList',
  components: {
    pageTitle,
    pageFoot,
    noMore,
    Infos
  },
  data () {
    return {
      userId: 0,
      name: '',
      infoList: [],
      extinfo: 'yslt://?name=galleryPerson&',
      isSuspension: false // 控制是否显示打开APP
    }
  },
  async created () {
    this.getA()
    await this.getInfoTotal()
    this.changeTitleClick()
    this.weixin()
    this.extinfo = this.extinfo + `userId=${this.userId}`
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    // 修改微信的网页标题
    changeTitleClick () {
      const title = this.name + '的相关资讯'
      changeTitleClick(title)
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log(res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.name + '的相关资讯',
          desc: this.name + '的相关资讯',
          link: `http://room.yslt.art/SharePageTest/?userId=${this.userId}&name=${this.name}#/artlist`,
          imgUrl: 'http://artsss.oss-cn-hangzhou.aliyuncs.com/app/share1.png'
        })
      })
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    // 获取艺术家资讯
    async getInfoTotal () {
      try {
        const res = await getInfoReport(this.userId)
        this.infoList = res.result.records
      } catch (error) {
        console.log('获取艺术家资讯失败', error)
      }
    },
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.userId = obj.userId
      this.name = decodeURIComponent(obj.name)
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-list {
  padding: 10px 0 30px 0;
}
.suspension {
  width: 153px;
  height: 45px;
  background: rgba(196, 148, 107, 0.9);
  font-size: 16px;
  color: #fff;
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    margin-left: 6px;
  }
}
</style>
